/**
 * Brand-aware logo component. Renders Baiglabs or InterviewFlow logo based on domain.
 */
import React from 'react';
import { getBrand } from '../config/brand.js';
import BaiglabsCombinedLogo from './BaiglabsCombinedLogo';
import InterviewFlowCombinedLogo from './InterviewFlowCombinedLogo';

function BrandLogo(props) {
  const brand = getBrand();
  return brand === 'interviewflow'
    ? <InterviewFlowCombinedLogo {...props} />
    : <BaiglabsCombinedLogo {...props} />;
}

export default BrandLogo;
